import { render, staticRenderFns } from "./FormFieldCheckbox.vue?vue&type=template&id=12fbd0d0&"
import script from "./FormFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormFieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports